<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-md-6 form-group">
                <label for="job">Job</label>
                <wj-combo-box
                    [(ngModel)]="target.job"
                    name="job"
                    id="job"
                    [itemsSource]="jobOptions"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </div>
            <div class="col-md-6 form-group">
                <label for="initiatedBy">Requested/Initiated By</label>
                <wj-combo-box
                    [(ngModel)]="target.initiatedBy"
                    name="initiatedBy"
                    id="initiatedBy"
                    [isRequired]="true"
                    [itemsSource]="initiatedByOptions"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 form-group">
                <label for="description">Description</label>
                <app-voice-text-field
                    [(ngModel)]="target.description"
                    name="description"
                    inputId="description"
                    inputMode="text"
                ></app-voice-text-field>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 form-group">
                <label for="dateInitiated">Date Initiated</label>
                <wj-input-date
                    [(ngModel)]="target.dateInitiated"
                    name="dateInitiated"
                    id="dateInitiated"
                    [isRequired]="false"
                ></wj-input-date>
            </div>
            <div class="col-md-4 form-group">
                <label for="workType">Work Type</label>
                <wj-combo-box
                    [(ngModel)]="target.workType"
                    (ngModelChange)="onWorkTypeChange($event)"
                    name="workType"
                    id="workType"
                    [isRequired]="true"
                    [itemsSource]="workTypeOptions"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </div>
            <div class="col-md-4 form-group">
                <label for="pricingMethod">Pricing Method</label>
                <wj-combo-box
                    [(ngModel)]="target.pricingMethod"
                    name="pricingMethod"
                    id="pricingMethod"
                    [isRequired]="true"
                    [itemsSource]="pricingMethodOptions"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 form-group">
                <label for="approxCost">Approximate Cost</label>
                <wj-input-number
                    [(ngModel)]="target.approxCost"
                    name="approxCost"
                    id="approxCost"
                    [isRequired]="false"
                    [format]="'c2'"
                ></wj-input-number>
            </div>
            <div class="col-md-4 form-group">
                <label for="rfiNumber">Resulted from RFI#</label>
                <input type="text" class="form-control" [(ngModel)]="target.rfiNumber" name="rfiNumber" id="rfiNumber" />
            </div>
            <div class="col-md-4 form-group">
                <label for="ownerAcknowledgedDate">Owner Acknowledged</label>
                <date-set-today-toggle
                    [(ngModel)]="target.ownerAcknowledgedDate"
                    name="ownerAcknowledgedDate"
                    inputId="ownerAcknowledgedDate"
                    inputName="ownerAcknowledgedDate"
                    checkboxAriaLabel="Owner acknowledged (set to today)"
                    [isRequired]="false"
                ></date-set-today-toggle>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 form-group">
                <label for="wcdNumber">WCD#</label>
                <input type="text" class="form-control" [(ngModel)]="target.wcdNumber" name="wcdNumber" id="wcdNumber" />
            </div>
            <div class="col-md-4 form-group">
                <label for="pcoNumber">PCO# Assigned</label>
                <input type="text" class="form-control" [(ngModel)]="target.pcoNumber" name="pcoNumber" id="pcoNumber" />
            </div>
            <div class="col-md-4 form-group">
                <label for="ownerCoNumber">Owner CO#</label>
                <input type="text" class="form-control" [(ngModel)]="target.ownerCoNumber" name="ownerCoNumber" id="ownerCoNumber" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 form-group">
                <label for="hbNumber">HB#</label>
                <wj-combo-box
                    [(ngModel)]="target.hbNumber"
                    name="hbNumber"
                    id="hbNumber"
                    [isRequired]="false"
                    [isEditable]="true"
                    [itemsSource]="estimateCodeOptions"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </div>
            <div class="col-md-6 form-group">
                <label for="waitingOnQuotes">Waiting On Quotes or Backup?</label>
                <input type="text" class="form-control" [(ngModel)]="target.waitingOnQuotes" name="waitingOnQuotes" id="waitingOnQuotes" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 form-group">
                <label for="proceedToWork">Proceed to Work</label>
                <date-set-today-toggle
                    [(ngModel)]="target.proceedToWork"
                    name="proceedToWork"
                    inputId="proceedToWork"
                    inputName="proceedToWork"
                    checkboxAriaLabel="Proceed to work (set to today)"
                    [isRequired]="false"
                ></date-set-today-toggle>
            </div>
            <div class="col-md-6 form-group">
                <label for="readyForApprovalDate">Ready for Approval</label>
                <date-set-today-toggle
                    [(ngModel)]="target.readyForApprovalDate"
                    name="readyForApprovalDate"
                    inputId="readyForApprovalDate"
                    inputName="readyForApprovalDate"
                    checkboxAriaLabel="Ready for approval (set to today)"
                    [isRequired]="false"
                ></date-set-today-toggle>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 form-group">
                <label for="programMgrApprovalDate">Program Mngr Approval</label>
                <date-set-today-toggle
                    [(ngModel)]="target.programMgrApprovalDate"
                    [disabled]="isProgramMgrApprovalDisabled"
                    name="programMgrApprovalDate"
                    inputId="programMgrApprovalDate"
                    inputName="programMgrApprovalDate"
                    checkboxAriaLabel="Program manager approval (set to today)"
                    [isRequired]="false"
                ></date-set-today-toggle>
            </div>
            <div class="col-md-6 form-group">
                <label for="vpApprovalDate">VP Approval >$20k</label>
                <date-set-today-toggle
                    [(ngModel)]="target.vpApprovalDate"
                    [disabled]="isVpApprovalDisabled"
                    name="vpApprovalDate"
                    inputId="vpApprovalDate"
                    inputName="vpApprovalDate"
                    checkboxAriaLabel="VP approval (set to today)"
                    [isRequired]="false"
                ></date-set-today-toggle>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3 form-group">
                <label for="sentToOwnerDate">Sent to Owner</label>
                <date-set-today-toggle
                    [(ngModel)]="target.sentToOwnerDate"
                    (ngModelChange)="onSentToOwnerDateChange($event)"
                    [disabled]="isSentToOwnerRowDisabled"
                    name="sentToOwnerDate"
                    inputId="sentToOwnerDate"
                    inputName="sentToOwnerDate"
                    checkboxAriaLabel="Sent to owner (set to today)"
                    [isRequired]="false"
                ></date-set-today-toggle>
            </div>
            <div class="col-md-3 form-group">
                <label for="ownerAuthorizedDate">Owner Authorized</label>
                <date-set-today-toggle
                    [(ngModel)]="target.ownerAuthorizedDate"
                    [disabled]="isSentToOwnerRowDisabled"
                    name="ownerAuthorizedDate"
                    inputId="ownerAuthorizedDate"
                    inputName="ownerAuthorizedDate"
                    checkboxAriaLabel="Owner authorized (set to today)"
                    [isRequired]="false"
                ></date-set-today-toggle>
            </div>
            <div class="col-md-3 form-group">
                <label for="ownerExecutedDate">Owner Executed</label>
                <date-set-today-toggle
                    [(ngModel)]="target.ownerExecutedDate"
                    [disabled]="isSentToOwnerRowDisabled"
                    name="ownerExecutedDate"
                    inputId="ownerExecutedDate"
                    inputName="ownerExecutedDate"
                    checkboxAriaLabel="Owner executed (set to today)"
                    [isRequired]="false"
                ></date-set-today-toggle>
            </div>
            <div class="col-md-3 form-group">
                <label for="importedIntoVistaDate">Imported into Vista</label>
                <date-set-today-toggle
                    [(ngModel)]="target.importedIntoVistaDate"
                    [disabled]="isSentToOwnerRowDisabled"
                    name="importedIntoVistaDate"
                    inputId="importedIntoVistaDate"
                    inputName="importedIntoVistaDate"
                    checkboxAriaLabel="Imported into Vista (set to today)"
                    [isRequired]="false"
                ></date-set-today-toggle>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 form-group">
                <label for="notes">Additional Notes</label>
                <app-voice-text-field
                    [(ngModel)]="target.notes"
                    name="notes"
                    inputId="notes"
                    [rows]="3"
                ></app-voice-text-field>
            </div>
        </div>
        @if (target.imageUrls && target.imageUrls.length > 0) {
            <div class="row">
                <label>Images/Files</label>
                @for (url of target.imageUrls; track url) {
                    <div class="col-sm-6 col-6" style="margin-bottom: 10px">
                        @if (isVideo(url)) {
                            <video style="max-width: 250px; cursor: pointer" [src]="getExistingFileSrc(url)" (click)="openImage(url)" muted preload="metadata"></video>
                        } @else if (isPdf(url)) {
                            <img class="attachment-pdf-thumb" style="cursor: pointer" src="./Resources/pdfImage.png" (click)="openImage(url)" alt="" />
                        } @else {
                            <img style="max-width: 250px; cursor: pointer" [src]="getExistingImageSrc(url)" (click)="openImage(url)" />
                        }
                    </div>
                }
            </div>
        }
        @if (images && images.length > 0) {
            <div class="row">
                <label>Photos To Upload</label>
                @for (image of images; track image) {
                    <div class="col-sm-6 col-6" style="max-width: 324px; margin-bottom: 10px">
                        <div class="close-x" (click)="removeImage(image)">
                            <fa-icon [icon]="faX"></fa-icon>
                        </div>
                        @if (image.type === 'application/pdf') {
                            <img class="attachment-pdf-thumb" [src]="getPendingImageSrc(image)" alt="" />
                        } @else {
                            <img style="max-width: 300px" [src]="getPendingImageSrc(image)" alt="" />
                        }
                    </div>
                }
            </div>
        }
        @if (videos && videos.length > 0) {
            <div class="row">
                <label>Videos To Upload</label>
                @for (video of videos; track video) {
                    <div class="col-12" style="margin-bottom: 5px">
                        <div class="close-x" style="display: inline-block; margin-right: 8px; cursor: pointer" (click)="removeVideo(video)">
                            <fa-icon [icon]="faX"></fa-icon>
                        </div>
                        <span>{{ video.name }}</span>
                    </div>
                }
            </div>
        }
        @if (documents && documents.length > 0) {
            <div class="row">
                <label>Documents To Upload</label>
                @for (doc of documents; track doc) {
                    <div class="col-12" style="margin-bottom: 5px">
                        <div
                            class="close-x"
                            style="display: inline-block; margin-right: 8px; cursor: pointer"
                            (click)="removeDocument(doc)"
                        >
                            <fa-icon [icon]="faX"></fa-icon>
                        </div>
                        <span>{{ doc.name }}</span>
                    </div>
                }
            </div>
        }
        @if (progress > 0 && progress < 100) {
            <div class="row">
                <div class="col-12">
                    <div class="progress">
                        <div
                            class="progress-bar"
                            role="progressbar"
                            [ngStyle]="{ 'width.%': progress }"
                            [attr.aria-valuenow]="progress"
                            aria-valuemin="0"
                            aria-valuemax="100"
                        >
                            {{ progress }}%
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>
    <div class="modal-footer">
        <div style="margin-right: auto">
            <button type="button" class="btn btn-success me-1" (click)="photoInput.click()">Photo</button>
            <input style="display: none" type="file" (change)="onPhotoChanged($event)" accept="image/*" #photoInput multiple />
            <button type="button" class="btn btn-success me-1" (click)="videoInput.click()">Video</button>
            <input style="display: none" type="file" (change)="onVideoChanged($event)" accept="video/*" #videoInput />
            <button type="button" class="btn btn-success" (click)="docInput.click()">Document</button>
            <input
                style="display: none"
                type="file"
                (change)="onDocumentChanged($event)"
                accept=".pdf,.doc,.docx,.xls,.xlsx,.txt"
                #docInput
                multiple
            />
        </div>
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
